import Devices from "./Devices";
export { default as DeviceList } from "./DeviceList";
export { default as DeviceForm } from "./DeviceForm";
export { default as DeviceView } from "./DeviceView";
export default Devices;
